import React from 'react';
const SportsCoaches = () => <div className="service-page"><h1>Sports Coaches</h1><p>Professional sports coaches for all age groups.</p></div>;
export default SportsCoaches;
